var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1483 133C93.3673 133 120.297 106.12 120.297 72.9606C120.297 39.8016 93.3673 12.9209 60.1483 12.9209C26.9293 12.9209 0 39.8016 0 72.9606C0 106.12 26.9293 133 60.1483 133Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1485 120.992C86.7237 120.992 108.267 99.4877 108.267 72.9605C108.267 46.4333 86.7237 24.9287 60.1485 24.9287C33.5732 24.9287 12.0298 46.4333 12.0298 72.9605C12.0298 99.4877 33.5732 120.992 60.1485 120.992Z",
    fill: "#002D70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1481 108.984C80.0795 108.984 96.2371 92.8558 96.2371 72.9604C96.2371 53.0649 80.0795 36.9365 60.1481 36.9365C40.2167 36.9365 24.0591 53.0649 24.0591 72.9604C24.0591 92.8558 40.2167 108.984 60.1481 108.984Z",
    fill: "#116EEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1482 96.9761C73.4358 96.9761 84.2075 86.2238 84.2075 72.9602C84.2075 59.6966 73.4358 48.9443 60.1482 48.9443C46.8606 48.9443 36.0889 59.6966 36.0889 72.9602C36.0889 86.2238 46.8606 96.9761 60.1482 96.9761Z",
    fill: "#E81111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1483 84.968C66.7921 84.968 72.178 79.5919 72.178 72.9601C72.178 66.3283 66.7921 60.9521 60.1483 60.9521C53.5045 60.9521 48.1187 66.3283 48.1187 72.9601C48.1187 79.5919 53.5045 84.968 60.1483 84.968Z",
    fill: "#FFE333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.707 13.0622L58.4221 71.2419C57.5342 72.1282 57.5342 73.5652 58.4221 74.4515C59.31 75.3378 60.7496 75.3378 61.6375 74.4515L119.922 16.2718C120.81 15.3855 120.81 13.9485 119.922 13.0622C119.035 12.1759 117.595 12.1759 116.707 13.0622Z",
    fill: "#A97417"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9141 34.823L95.3712 19.705L115.112 0L115.569 14.2054L94.9141 34.823Z",
    fill: "#FDC000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.126 38.0288L113.271 37.5725L133 17.8674L118.781 17.4111L98.126 38.0288Z",
    fill: "#FDC000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/Goal.12325f7e83c4746c9437b7db2c1acdf3.svg";
export { ForwardRef as ReactComponent };